import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

class Duration extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      fieldId,
      answer,
      placeHolder,
      stylesClasses,
      showFieldErrors,
      duration_fields,
      answers,
      isRequired
    } = this.props;
    let message = {};
    const startDate = new Date(answers?.[duration_fields?.startDateField?.fieldId]);
    const endDate = new Date(answers?.[duration_fields?.endDateField?.fieldId]);
    if ((startDate > endDate || answer?.toString() === 'NaN') && !message?.id) {
      message = {
        'id': 'pulpoforms.errors.invalid_duration',
        'message': 'Invalid Duration'
      };
    }
    if (isRequired && !answer && !message?.id) {
      message = {
        'id': 'pulpoforms.errors.not_blank',
        'message': 'This field cannot be empty'
      };
    }
    return (
      <div>
        <input
          type="text"
          name={`string-field-${fieldId}`}
          value={answer}
          disabled
          onChange={e => this.handleAnswerChanged(e.target.value, fieldId)}
          className={`pulpo-charfield ${stylesClasses}`}
          placeholder={placeHolder || ''}
        />
        {showFieldErrors && message?.id && (
          <>
            <small>
              <FormattedMessage
                id={message?.id}
                defaultMessage={message?.message}
              />
            </small>
          </>
        )}
      </div>
    );
  }
}

export default Duration;
